<template>
  <div class="sensitive-case container">
    <div class="sizer">
      <h2>{{ $t('outlierDefinitionQuestion') }}</h2>
      <div class="entries">
        <div class="entry">
          <i class="material-icons">keyboard_arrow_right</i>
          <span class="description">{{ $t('outlierDefinitionSegment1') }}</span>
          <span class="data-value">> 45 <small>min</small></span>
        </div>
        <div class="and">&amp;</div>
        <div class="entry">
          <i class="material-icons">keyboard_arrow_right</i>
          <span class="description">{{ $t('outlierDefinitionSegment2') }}</span>
          <span class="data-value">+ 20 <small>min</small></span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
.sensitive-case {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  h2 {
    font-size: 4em;
  }

  .entries {
    display: flex;
    margin-top: 2em;

    .and {
      margin: 8px 64px 8px 24px;
      font-size: 3em;
    }

    .entry {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      & + .entry {
        margin-left: 13.75em;
      }
      i {
        color: colors.$main-color;
        font-size: 3em;
        position: absolute;
        right: 100%;
        top: 0;
      }
      .description {
        font-size: 2em;
        max-width: 10em;
      }
      .data-value {
        font-size: 6.25em;
        font-weight: 300;
        small {
          font-size: 0.46em;
        }
      }
    }
  }
}
.main-content + .sensitive-case {
  max-height: 0;
  font-size: 0.875em;
  justify-content: flex-start;

  .entries {
    flex-direction: column;
    .entry {
      flex-direction: row;
      align-items: flex-start;
      & + .entry {
        margin-left: 0em;
        margin-top: 1.3em;
      }
      i {
        position: relative;
        top: initial;
        right: initial;
      }
      .description {
        margin-right: 1em;
      }
      .data-value {
        line-height: 0.75em;
      }
    }
  }
}
</style>
